import { StatusPill } from "../../StatusPill";
import { Text } from "../../Text";
import type { ProviderStatus } from "./providerStatus";

export function StatusCell({ status }: { status: ProviderStatus }) {
  return (
    <StatusPill
      passive
      color={status.color}
      label={status.label}
      detail={
        <Text variant="text-small-md" color="var(--tooltip-fg)">
          {status.detail ?? "Ready to use."}
        </Text>
      }
      compactIcon={status.color === "green" ? "check" : "circle-dashed"}
    />
  );
}
